import { background, black } from "@/modules/irohana-components/theme/colors";
import { Stack, StackProps, styled } from "@mui/material";
import { FC } from "react";

type TFooterProps = StackProps & {
  children: React.ReactNode;
};

export const FooterActionBar: FC<TFooterProps> = ({ children, ...props }) => {
  return <StyledFooter {...props}>{children}</StyledFooter>;
};

const StyledFooter = styled(Stack)`
  padding: 24px;
  border-radius: 8px;
  border: 1px solid ${black[99]};
  background-color: ${background.white};
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);
  position: sticky;
  bottom: 20px;
  border: none;
  z-index: 2;
`;
